import { DropdownButton } from "../toolbar-buttons";
import DatePicker from "frontend/ui-components/date-picker";
import { format } from "date-fns";
import style from "./toolbarDatePicker.module.css";

export default function ToolbarDatePicker({
  value,
  onChange,
  title,
}: {
  value: number;
  onChange: (date: number) => void;
  title?: string;
}) {
  const date = value && new Date(value);

  function onSelectDate(date: Date) {
    onChange(date.getTime());
  }

  function renderPicker() {
    return (
      <div className={style.pickerContainer}>
        <DatePicker selected={value ? new Date(value) : new Date()} onSelected={onSelectDate} />
      </div>
    );
  }

  function renderSelectedDate() {
    if (!date) {
      return "Not selected";
    }

    return format(date, "dd/MM/yyyy");
  }

  return (
    <div className={style.title} data-testid="ToolbarDatePicker">
      {title}
      <DropdownButton renderPopup={renderPicker}>{renderSelectedDate()}</DropdownButton>
    </div>
  );
}
